import { defineStore } from 'pinia'

export const useFacilityStore = defineStore('facility', {
  state: () => ({
    id: null,
    name: null,
  }),
})
